import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-[1280px]">
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10 md:mb-14">
            <div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
                更新动态
              </h2>
              <p className="text-sm text-foreground-600">实时追踪韩国漫画最新更新，不再错过任何精彩</p>
            </div>
            <span className="inline-flex items-center gap-1.5 text-xs text-accent-600 font-medium">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
              实时更新中
            </span>
          </div>

          <div className="relative pl-6 md:pl-8 border-l-2 border-secondary-200">
            {updateItems.map((item, i) => (
              <div
                key={i}
                className={`relative pb-7 last:pb-0 ${
                  i < updateItems.length - 1 ? 'mb-1' : ''
                }`}
              >
                <div className="absolute -left-[25px] md:-left-[29px] top-1 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-bold ${
                    item.type === '新作'
                      ? 'bg-accent-100 text-accent-700'
                      : item.type === '专题'
                      ? 'bg-secondary-100 text-secondary-700'
                      : 'bg-primary-100 text-primary-700'
                  }`}>
                    {item.type}
                  </span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
                <p className="text-sm text-foreground-800 font-medium">{item.title}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <a
              href="#ranking"
              className="whitespace-nowrap inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors"
            >
              查看更多动态
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}